import {
  TeamProfileDomainQueryModelSchema,
  TeamProfileDomainUpsertModelSchema,
} from '@mntn-dev/domain-types'
import type { ZodInfer } from '@mntn-dev/utility-types'

import { TeamQueryShapeSchema } from '../types.ts'
import { TeamAclSchema } from './get-team.models.ts'
import { UpdateTeamInputSchema } from './update-team.models.ts'

export const UpdateTeamWithProfileInputSchema = UpdateTeamInputSchema.extend({
  profile: TeamProfileDomainUpsertModelSchema,
})

export type UpdateTeamWithProfileInput = ZodInfer<
  typeof UpdateTeamWithProfileInputSchema
>

export const UpdateTeamWithProfileOutputSchema = TeamQueryShapeSchema.extend({
  acl: TeamAclSchema,
  profile: TeamProfileDomainQueryModelSchema,
})

export type UpdateTeamWithProfileOutput = ZodInfer<
  typeof UpdateTeamWithProfileOutputSchema
>
